import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-sand pt-16 pb-8" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-75">
          <div className="col-span-1 md:col-span-2" data-id="element-76">
            <h3 className="font-serif text-2xl tracking-wider uppercase mb-4 text-white" data-id="element-77">
              Cabo Collection
            </h3>
            <p className="text-sand/80 max-w-md mb-6 font-light leading-relaxed" data-id="element-78">
              More than real estate. We are your gateway to the ultimate Cabo
              lifestyle, connecting you with the finest properties and a vetted
              collective of local professionals.
            </p>
            <div className="flex space-x-4" data-id="element-79">
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-80">
                <Instagram size={20} data-id="element-81" />
              </a>
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-82">
                <Facebook size={20} data-id="element-83" />
              </a>
            </div>
          </div>

          <div data-id="element-84">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-85">Explore</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-86">
              <li data-id="element-87">
                <Link to="/buyers" className="hover:text-gold transition-colors" data-id="element-88">
                  For Buyers
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/sellers" className="hover:text-gold transition-colors" data-id="element-90">
                  For Sellers
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/collective" className="hover:text-gold transition-colors" data-id="element-92">
                  The Collective
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-94">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-95">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-96">Connect</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-97">
              <li className="flex items-center space-x-2" data-id="element-98">
                <MapPin size={16} className="text-gold" data-id="element-99" />
                <span data-id="element-100">Cabo San Lucas, BCS, Mexico</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-101">
                <Phone size={16} className="text-gold" data-id="element-102" />
                <span data-id="element-103">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-104">
                <Mail size={16} className="text-gold" data-id="element-105" />
                <span data-id="element-106">hello@cabocollection.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sand/20 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-sand/60" data-id="element-107">
          <p data-id="element-108">
            &copy; {new Date().getFullYear()} Cabo Collection. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-109">
            Looking for investment deals? Visit our sister site:{' '}
            <a href="https://cabodealflow.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-110">
              CaboDealFlow.com
            </a>
          </p>
        </div>
      </div>
    </footer>;
}